// LICENSE_CODE ZON
/*jslint react:true*/
import React from 'react';
import {Loader} from './comp/loader.js';

export function Suspense({children, page_height, loader_delay_ms}){
    return <React.Suspense fallback={<Loader size="xxl"
      page_height={page_height} delay_ms={loader_delay_ms}/>}>
      {children}
    </React.Suspense>;
}
